<template>
  <ele-loading :loading="loading" text="AI正在制作中，请稍等片刻~~">
    <ele-card :body-style="{ border: 0 }">
      <div class="info-user">
        <div class="info-user-avatar" @click="openCropper">
          <el-avatar :size="100" :src="data.avatar" />
          <el-icon class="info-user-avatar-icon">
            <CloudUploadOutlined style="stroke-width: 3" />
          </el-icon>
        </div>
        <div>
          <el-button
            type="primary"
            plain
            @click="handleAiAssistance"
            size="small"
            ><el-icon><MagicStick /></el-icon>AI生成头像</el-button
          >
        </div>
        <ele-text size="xxl" style="margin-top: 5px">
          {{ data.username }}
        </ele-text>
        <ele-text type="placeholder">
          {{ data.profile || '暂无个人简介' }}
        </ele-text>
      </div>
      <el-divider border-style="dashed" style="margin: 0" />
      <!-- 头像裁剪弹窗 -->
      <ele-cropper-modal
        v-model="visible"
        :src="cropperSrc"
        :options="{
          aspectRatio: 1,
          autoCropArea: 1,
          viewMode: 1,
          dragMode: 'move'
        }"
        :to-blob="true"
        :modal-props="{ destroyOnClose: true }"
        @done="onCrop"
      />
    </ele-card>
  </ele-loading>
</template>

<script lang="ts" setup>
  import { ref } from 'vue';
  import { CloudUploadOutlined } from '@/components/icons';
  import fileUtil, { FileUploadPkConfig } from '@/utils/file-util';
  import { EleMessage } from 'ele-admin-plus';
  import { updateUserInfo } from '@/api/bsl/tenant/user';
  import type { TenantUser } from '@/api/bsl/tenant/user/model';
  import { ElMessageBox } from 'element-plus';
  import { MagicStick } from '@element-plus/icons-vue';

  const props = defineProps<{
    data: TenantUser;
  }>();

  const emit = defineEmits<{
    (e: 'done', value: TenantUser): void;
  }>();

  /** 是否显示裁剪弹窗 */
  const visible = ref(false);
  const loading = ref(false);

  /** 裁剪图片地址 */
  const cropperSrc = ref('');

  /** 打开图片裁剪 */
  const openCropper = () => {
    cropperSrc.value = cropperSrc.value
      ? cropperSrc.value
      : (props.data.avatar ?? '');
    loading.value = false;
    visible.value = true;
  };

  /** 头像裁剪完成回调 */
  const onCrop = async (cropResult: Blob) => {
    visible.value = false;
    fileUtil
      .uploadFile(
        FileUploadPkConfig.signatureImage,
        new File([cropResult], 'avatar.png')
      )
      .then((data: any) => {
        let fileUrl = null;
        if (data && (fileUrl = data.fileUrl)) {
          updateUserInfo({ avatar: fileUrl })
            .then((_) => {
              EleMessage.success('保存成功');
              emit('done', { avatar: fileUrl! });
            })
            .catch((e) => {
              EleMessage.error(e.message);
            });
        }
      })
      .catch((e) => {
        EleMessage.error(e.message);
      });
  };
  // 硅基流动接口对接
  const API_KEY = 'sk-kizjoxsymborypydvuexwnuxsaeivzjwexjlvelagfdtaxjc';
  const API_URL = 'https://api.siliconflow.cn/v1/images/generations';

  async function handleAiAssistance() {
    ElMessageBox.prompt('', '输入对应提示词', {
      confirmButtonText: '确定',
      cancelButtonText: '取消',
      inputType: 'textarea',
      inputValidator: (value) => {
        if (!value.trim()) {
          return '不能为空';
        }
        return true;
      }
    }).then(async ({ value }) => {
      loading.value = true;
      const options = {
        method: 'POST',
        headers: {
          Authorization: `Bearer ${API_KEY}`,
          'Content-Type': 'application/json'
        },
        body: `{"model":"Kwai-Kolors/Kolors","prompt":"${value}","image_size":"1024x1024","batch_size":1,"num_inference_steps":20,"guidance_scale":7.5}`
      };

      fetch(API_URL, options)
        .then((response) => response.json())
        .then((response) => {
          cropperSrc.value = response.images[0].url;
          openCropper();
        })
        .catch((err) => EleMessage.error(err));
    });
  }
</script>

<style lang="scss" scoped>
  .info-user {
    padding-top: 8px;
    box-sizing: border-box;
    text-align: center;

    .info-user-avatar {
      display: inline-block;
      position: relative;
      cursor: pointer;
      line-height: 0;

      .info-user-avatar-icon {
        position: absolute;
        top: 50%;
        left: 50%;
        transform: translate(-50%, -50%);
        color: #fff;
        font-size: 30px;
        display: none;
        z-index: 2;
      }

      &::after {
        content: '';
        position: absolute;
        top: 0;
        left: 0;
        width: 100%;
        height: 100%;
        border-radius: 50%;
        background-color: transparent;
        transition: background-color 0.3s;
      }

      &:hover {
        .info-user-avatar-icon {
          display: block;
        }

        &::after {
          background-color: rgba(0, 0, 0, 0.4);
        }
      }
    }
  }

  .info-list {
    margin: 35px 0 24px 0;

    .info-item {
      display: flex;
      align-items: center;

      & > .el-icon {
        font-size: 16px;
      }

      .info-item-text {
        flex: 1;
        padding-left: 8px;
        box-sizing: border-box;
      }

      & + .info-item {
        margin-top: 10px;
      }
    }
  }

  .info-tags .el-tag {
    margin: 0 12px 8px 0;
  }
</style>
